import { useNavigate } from 'react-router-dom';
import ActionCard from '../../components/SharedLayouts/ActionLayout/ActionCard';
import error from '../../assets/img/baja.png'

const UnsubscribeError = () => {
    const navigate = useNavigate();

    const goToContact = () => {
        navigate('/monitor/contactanos')
    }

    return (
        <ActionCard
            image={error}
            alt="Error en darse de baja"
            title="¡No pudimos procesar tu baja!"
            description="Ocurrió un error al intentar darte de baja de nuestras novedades. Por favor, volvé a intentarlo más tarde. Si el problema persiste, contactanos a través de la sección de contacto."
            buttonLabel="Ir a la página de ayuda"
            onClick={goToContact}
            buttonDisabled={false}
        />
    )
}

export default UnsubscribeError